import { arredondarMoeda } from "./moeda";

export default function (number) {
  const roundedNumber = arredondarMoeda(number).toFixed(2);
  const parts = roundedNumber.split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalPart = ',' + parts[1];
  return integerPart + decimalPart;
}
